<template>
    <div class="container">
      <h1>SQL CheatSheet</h1>
      <p class="description">Comandos essenciais de SQL organizados em DDL e DML, com exemplos práticos.</p>
  
      <div class="cheat-sheet">
        <!-- Primeira Coluna -->
        <div class="column">
          <h2>📌 DDL (Definição de Dados)</h2>
  
          <p><b>Criar Banco de Dados:</b></p>
          <code>CREATE DATABASE escola;</code>
  
          <p><b>Usar Banco de Dados:</b></p>
          <code>USE escola;</code>
  
          <p><b>Criar Tabela `alunos`:</b></p>
          <code>
            CREATE TABLE alunos ( <br>
            &nbsp;&nbsp;id INT PRIMARY KEY AUTO_INCREMENT, <br>
            &nbsp;&nbsp;nome VARCHAR(100) NOT NULL, <br>
            &nbsp;&nbsp;idade INT, <br>
            &nbsp;&nbsp;curso VARCHAR(50) <br>
            );
          </code>
  
          <p><b>Adicionar Coluna `email`:</b></p>
          <code>ALTER TABLE alunos ADD email VARCHAR(100);</code>
  
          <p><b>Renomear Coluna:</b></p>
          <code>ALTER TABLE alunos CHANGE idade data_nascimento DATE;</code>
  
          <p><b>Remover Coluna:</b></p>
          <code>ALTER TABLE alunos DROP COLUMN email;</code>
  
          <p><b>Excluir Tabela:</b></p>
          <code>DROP TABLE alunos;</code>
  
          <p><b>Excluir Banco de Dados:</b></p>
          <code>DROP DATABASE escola;</code>
        </div>
  
        <!-- Segunda Coluna -->
        <div class="column">
          <h2>📌 DML (Manipulação de Dados)</h2>
  
          <p><b>Inserir Dados em `alunos`:</b></p>
          <code>
            INSERT INTO alunos (nome, idade, curso) VALUES <br>
            ('Carlos Silva', 22, 'Engenharia'), <br>
            ('Ana Souza', 21, 'Administração');
          </code>
  
          <p><b>Selecionar Todos os Dados:</b></p>
          <code>SELECT * FROM alunos;</code>
  
          <p><b>Selecionar Apenas Nome e Curso:</b></p>
          <code>SELECT nome, curso FROM alunos;</code>
  
          <p><b>Filtrar Alunos de Engenharia:</b></p>
          <code>SELECT * FROM alunos WHERE curso = 'Engenharia';</code>
  
          <p><b>Atualizar Nome do Aluno:</b></p>
          <code>UPDATE alunos SET nome = 'Carlos S.' WHERE id = 1;</code>
  
          <p><b>Excluir um Aluno:</b></p>
          <code>DELETE FROM alunos WHERE id = 2;</code>
  
          <h2>📌 Comandos Avançados</h2>
  
          <p><b>Contar Quantidade de Alunos:</b></p>
          <code>SELECT COUNT(*) FROM alunos;</code>
  
          <p><b>Ordenar Alunos por Nome:</b></p>
          <code>SELECT * FROM alunos ORDER BY nome ASC;</code>
  
          <p><b>Juntar Duas Tabelas (JOIN):</b></p>
          <code>
            SELECT alunos.nome, cursos.nome AS curso <br>
            FROM alunos <br>
            INNER JOIN cursos ON alunos.curso_id = cursos.id;
          </code>
        </div>
      </div>
    </div>
  </template>
  
  <style scoped>
  .container {
    max-width: 900px;
    margin: auto;
    padding: 20px;
    text-align: center;
    font-family: "Arial", sans-serif;
  }
  
  h1 {
    font-size: 24px;
    margin-bottom: 10px;
  }
  
  .description {
    font-size: 16px;
    color: #555;
    margin-bottom: 20px;
  }
  
  .cheat-sheet {
    display: flex;
    justify-content: space-between;
    gap: 20px;
  }
  
  .column {
    width: 48%;
    background: #f8f9fa;
    padding: 20px;
    border-radius: 8px;
    text-align: left;
    line-height: 1.6;
  }
  
  h2 {
    font-size: 18px;
    margin-bottom: 10px;
    color: #007bff;
  }
  
  p {
    font-size: 14px;
    margin: 8px 0;
  }
  
  code {
    background: #e3e3e3;
    display: block;
    padding: 10px;
    border-radius: 5px;
    font-family: monospace;
    white-space: pre-line;
  }
  </style>
  